import { store } from 'redux/store';
import { Society, User } from 'types';

import boardStatus from 'constants/boardStatus';
import { boardAction } from 'modules/_shared/redux/modalsActions';
import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';

import { addBoardDocuments } from '../utils';

export type NewBoardData = {
  name: string;
  user: User;
  society: Society;
  files: File[];
  date: Date;
  attendanceType: string;
  place: string;
  onlineAccess: string;
  status: string;
  entityType: keyof typeof boardEntityTypes;
  comments: string;
};

export const saveBasicBoard = async (
  boardData: NewBoardData,
  isDuplicate = false
) => {
  const {
    name,
    user,
    files,
    society,
    date,
    attendanceType,
    place,
    onlineAccess,
    status,
    entityType,
    comments,
  } = boardData;

  try {
    const uploadedDocuments = !isDuplicate
      ? await addBoardDocuments({ files, user, society })
      : [];

    const newBoard: Record<string, any> = {
      name,
      status,
      date: date ? new Date(date) : new Date(),
      attendanceType,
      place,
      onlineAccess,
      entityType,
      comments,
      attachedDocuments: uploadedDocuments,
      society: society?.['_id'],
    };

    const board = await store.dispatch(boardAction(newBoard, false));

    return board;
  } catch (error) {
    throw new Error();
  }
};
